import '../../app-configuration/app-configuration.js';
import { KatapultPageElement, html } from '../../mixins/katapult-page-element.js';

import '@polymer/font-roboto/roboto.js';
import '@polymer/paper-toast/paper-toast.js';
import '@polymer/iron-icon/iron-icon.js';
import '@polymer/iron-icons/iron-icons.js';
import '@polymer/iron-icons/image-icons.js';
import '@polymer/iron-icons/editor-icons.js';
import '@polymer/iron-icons/maps-icons.js';
import '@polymer/iron-icons/social-icons.js';
import '@polymer/paper-tooltip/paper-tooltip.js';
import '@polymer/paper-dialog-scrollable/paper-dialog-scrollable.js';
import '@polymer/neon-animation/neon-animation.js';
import '../katapult-auth/katapult-auth.js';
import '../katapult-toolbar/katapult-toolbar.js';
import '../katapult-photo/katapult-photo.js';
import '../progress-bar/progress-bar.js';
import '../style-modules/paper-dialog-style.js';
import '../style-modules/paper-tooltip-style.js';
import '../job-chooser/job-chooser.js';
import '../paper-header/paper-header.js';
import '../input-element/input-element.js';
import '../bind-path/bind-path.js';
import '../../js/open-source/zipjs/zip.js';
import { Uploader } from './Uploader.js';
import calibratePhoto from '../calibrate-photo/calibrate-photo.js';
import { SquashNulls } from '../../modules/SquashNulls.js';
import { ImageClassifier } from './ImageClassifier.js';
import { AssociatePhotos } from '../../modules/AssociatePhotos.js';
import { uuidv4 } from '../../modules/browserUUIDv4.js';
import ProgressBar from '../../js/open-source/progressbar.js';
import { setJobMetadata } from '../katapult-maps-desktop/button_functions/set_job_metadata.js';
import { GetExifThumbnail } from '../../modules/GetExifThumbnail.js';
import { GetExif } from '../../modules/GetExif.js';
import { Path } from '../../modules/Path.js';
import { ToArray } from '../../modules/ToArray.js';
import { UpdateJobPermissions } from '../../modules/UpdateJobPermissions.js';

class KatapultUploadPage extends KatapultPageElement {
  static get template() {
    return html`
    <style include="paper-dialog-style paper-tooltip-style">
      :host {
        font-family: Roboto;
        --page-index: 0;
        --num-pages: 0;
      }
      #main {
        display: flex;
        flex-direction: column;
        background-color: var(--paper-grey-50);
      }
      #slideContainer {
        flex-grow: 1;
        display: flex;
        width: calc(var(--num-pages) * 100%);
        transition: transform 0.3s;
        transform: translateX(calc(var(--page-index) * -100% / var(--num-pages)));
        padding-bottom: 88px;
        min-height: 0;
      }
      #slideContainer > div {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        text-align: center;
        flex-grow: 1;
        font-size: 16pt;
        color: var(--primary-text-color-faded);
        flex-basis: 0;
        flex-grow: 1;
      }
      #numCameraPickerContainer {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
        width: 200px;
        border-radius: 100%;
        font-weight: bold;
        color: var(--primary-text-color-faded);
        @apply --shadow-elevation-2dp;
        background-color: white;
      }
      #numCameraPickerContainer span {
        font-size: 48pt;
      }
      #numCameraPickerContainer .buttons {
        position: relative;
        display: flex;
        flex-direction: column;
        margin-right: -24px;
      }
      #progressContainer {
        width: 100%;
        padding: 24px;
        box-sizing: border-box;
      }
      progress-bar {
        height: 36px;
        border-radius: 24px;
        --progress-color: var(--secondary-color-text-color);
        --progress-background-color: var(--secondary-color);
      }
      #buttonsContainer {
        padding: 24px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-shrink: 0;
        position: absolute;
        z-index: 2;
        width: 100%;
        bottom: 0;
      }
      #buttonsContainer > katapult-button {
        /* padding: 10px; */
        /* height: 48px; */
        /* width: 48px; */
        background-color: white;
        border-radius: 100%;
        @apply --shadow-elevation-2dp;
      }
      .cameraDropZone {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: stretch;
        margin: 24px;
        height: 160px;
        width: 160px;
        border-radius: 8px;
        background-color: white;
        color: var(--primary-text-color-faded);
        transition: box-shadow 0.3s;
        user-select: none;
        @apply --shadow-elevation-2dp;
        transition: all 0.3s;
      }
      .cameraDropZone:hover {
        cursor: pointer;
        @apply --shadow-elevation-4dp;
      }
      .cameraDropZone > .title, .cameraRow > .title, .jobRow > .title {
        padding: 8px;
        background-color: var(--paper-grey-800);
        color: white;
        font-size: 10pt;
        text-align: center;
        text-transform: uppercase;
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;
      }
      .jobRow > .title {
        display: flex;
        font-size: 12pt;
      }
      .cameraDropZone .body {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .cameraDropZone .body .numPhotos {
        font-weight: bold;
        font-size: 32pt;
      }
      .cameraDropZone .body .photosLabel {
        font-size: 10pt;
        text-transform: uppercase;
      }
      .cameraDropZone input {
        position: absolute;
        pointer-events: none;
        opacity: 0;
      }
      .cameraDropZone[hover] {
        /* background-color: var(--secondary-color); */
        /* color: white; */
        transform: scale(1.05);
        box-shadow: 0 0 8px var(--secondary-color);
      }
      #cameraDropZoneContainer {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
      }
      .warning {
        color: var(--paper-red-500);
      }
      .gears {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100px;
        width: 100px;
      }
      .gears iron-icon:first-child {
        height: 50%;
        width: 50%;
        animation-name: rotate-cw;
        animation-duration: 2s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
      }
      .gears iron-icon:last-child {
        height: 40%;
        width: 40%;
        margin-left: -9%;
        margin-bottom: 19%;
        animation-name: rotate-ccw;
        animation-duration: 2s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
      }
      @keyframes rotate-cw {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
      @keyframes rotate-ccw {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(-360deg);
        }
      }
      .subPagesContainer {
        position: relative;
        height: 100%;
      }
      .subPagesContainer > div {
        position: absolute;
        height: 100%;
        width: 100%;
        display: inherit;
        flex-direction: inherit;
        justify-content: inherit;
        align-items: inherit;
        flex-grow: 1;
        transform: translateY(12px);
        opacity: 0;
        pointer-events: none;
        transition: all 0.3s;
        box-sizing: border-box;
      }
      .subPagesContainer > div[visible] {
        transform: translateY(0px);
        opacity: 1;
        pointer-events: auto;
      }
      #findSyncsContainer, #uploadContainer {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        flex-grow: 1;
      }
      #findSyncsProgressContainer, #uploadProgressContainer {
        height: 200px;
        width: 200px;
      }
      #findSyncsProgress, #uploadProgress {
        position: absolute;
        height: inherit;
        width: inherit;
      }
      #findSyncsProgressContainer > .gears {
        position: absolute;
        height: inherit;
        width: inherit;
      }
      #findSyncsProgressContainer > iron-icon, #uploadProgressContainer > iron-icon {
        transition: transform 0.3s;
        color: var(--secondary-color);
        animation-name: scaleUpCircle;
        animation-duration: 0.3s;
        height: inherit;
        width: inherit;
      }
      @keyframes scaleUpCircle {
        from {transform: scale(0);}
        to {transform: scale(1);}
      }
      .thumbnail {
        position: relative;
        display: flex;
        width: 60px;
        height: 60px;
        margin: 8px;
        transition: all 0.1s;
        overflow: hidden;
        background-color: var(--paper-grey-300);
        box-sizing: border-box;
        border: 0 solid white;
        border-radius: 4px;
      }
      .thumbnail[sync="false"] {
        border-width: 4px;
        border-color: var(--paper-red-500);
      }
      .thumbnail[sync="true"] {
        border-width: 4px;
        border-color: var(--paper-green-500);
      }
      .thumbnail[highlight] {
        border-width: 4px;
        border-color: var(--paper-amber-500);
      }      
      .thumbnail[faded] .background {
        opacity: 0.2;
      }
      .thumbnail .icon {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        z-index: 1;
      }
      .thumbnail .background {
        background-size: cover;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        flex-grow: 1;
        margin: -8%;
      }
      .thumbnail .background[rotation="1"] {
        transform: rotate(90deg);
      }
      .thumbnail .background[rotation="2"] {
        transform: rotate(180deg);
      }
      .thumbnail .background[rotation="3"] {
        transform: rotate(270deg);
      }
      /* #syncThumbnailCircles {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        flex-wrap: wrap;
      }
      #syncThumbnailCircles .thumbnail {
        width: 60px;
        height: 60px;
        border-radius: 100%;
        @apply --shadow-elevation-2dp;
      }
      #syncThumbnailCircles .thumbnail:hover {
        cursor: pointer;
        transform: scale(1.1);
        @apply --shadow-elevation-4dp;
      } */
      #syncToolbar {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
      }
      #syncToolbar .thumbnail {
        box-sizing: border-box;
        width: 48px;
        height: 48px;
        margin: 2px;
      }
      #syncToolbar .thumbnail:hover {
        cursor: pointer;
      }
      #syncToolbar .thumbnail[highlight] {
        border: 4px solid var(--paper-amber-500);
      }
      #syncToolbar .thumbnail:first-of-type {
        border-top-left-radius: 24px;
        border-bottom-left-radius: 24px;
      }
      #syncToolbar .thumbnail:last-of-type {
        border-top-right-radius: 24px;
        border-bottom-right-radius: 24px;
      }
      #syncEditInputContainer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        flex-grow: 1;
        padding-left: 24px;
      }
      #syncEditContainer {
        position: relative;
        display: flex;
        height: 100%;
        /*width: 850px;*/
        padding: 24px;
        box-sizing: border-box;
        margin-right: -850px;
        opacity: 0;
        pointer-events: none;
        transition: all 0.3s;
        border-radius: 8px;
        background-color: white;
        @apply --shadow-elevation-2dp;
      }
      #syncEditContainer[visible] {
        margin-right: 24px;
        opacity: 1;
        pointer-events: auto;
      }
      #syncEditPhotoContainer {
        display: flex;
        flex-direction: column;
      }
      #syncEditContainer katapult-photo {
        width: 420px;
        overflow: hidden;
        border-radius: 8px;
      }
      .cameraRow, .jobRow {
        display: flex;
        flex-direction: column;
        min-height: 128px;
        width: 100%;
        border-radius: 8px;
        background-color: white;
        flex-shrink: 0;
        @apply --shadow-elevation-2dp;
      }
      .jobRow {
        max-width: calc(100% - 48px);
      }
      .cameraRow {
        max-height: 50%;
      }
      .jobRow .cameraRow {
        background-color: var(--paper-grey-50);
        margin: 12px;
        background-shadow: none;
      }
      .jobRow .cameraRow .title {
        background-color: var(--paper-grey-600);
      }
      .fieldCompleteCheckbox {
        --paper-checkbox-checked-color: #4caf50;
        --paper-checkbox-label-color: white;
        --paper-checkbox-unchecked-color: white;
      }
      #findSyncsContainer .cameraRow:not(:last-of-type), .jobRow:not(:last-of-type) {
        margin-bottom: 16px;
      }
      #findSyncsContainer .cameraRow:not(:last-of-type) {
        max-height: calc(50% - 16px);
      }
      #findSyncsContainer .cameraRow:first-of-type:last-of-type {
        max-height: 100%;
      }
      .cameraRow .body, .jobRow .body {
        flex-grow: 1;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        overflow-y: auto;
        padding: 8px;
      }
      .cameraRow .body .thumbnail {
        margin: 2px;
      }
      .cameraRow .body .thumbnail:hover {
        cursor: pointer;
      }
      #confirmDialog {
        max-width:500px;
      }
      .confirmButton {
        float: right;
        background-color: var(--primary-color);
        color: #fff;
      }
      .emailCard {
          background-color: var(--secondary-color);
          color: white;
          display: flex;
          align-items: center;
          justify-content: space-around;
          padding: 4px;
          padding-left: 8px;
          border-radius: 24px;
          margin: 4px;
      }
      .emailCard span {
        flex-grow: 1;
      }
      .emailCard iron-icon {
          color: white;
      }
      .emailCard iron-icon:hover {
          cursor: pointer;
      }
      .remoteEmailsInputContainer {
          display: flex;
          color: #222;
          display: flex;
          align-items: center;
      }
      .remoteEmailsInputContainer paper-input {
        flex-grow: 1;
      }
      job-chooser {
        --paper-input-container-underline-display: block;
      }
      input-element {
        --input-element-element: {
          flex-grow: 1;
          --paper-input-container-underline-display: initial;
        };
      }
      .cameraAssociationPercentage[red] {
        color: var(--paper-red-600);
      }
      .cameraConfigErrorPass {
        --iron-icon-fill-color: green
      }
      .cameraConfigErrorFail {
        --iron-icon-fill-color: red
      }
      #actionPanel {
        width:300px;
        font-size:12pt;
        margin-right:24px;
      }
    </style>
    <firebase-document id="uploadOptions" path="photoheight/company_space/[[userGroup]]/options/upload" data="{{uploadOptions}}" disabled="[[!signedIn]]"></firebase-document>
    <firebase-document id="companyModules" path="photoheight/company_space/[[userGroup]]/subscription/modules" data="{{companyModules}}"></firebase-document>
    <paper-toast id="toast"></paper-toast>
    <!-- TODO: this dialog needs to be converted to a katapult-dialog so that it can be a proper modal -->
    <paper-dialog id="permissionRequiredDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation" no-cancel-on-esc-key no-cancel-on-outside-click>
      <div title="" red="">
        <div>Permission Required</div>
      </div>
      <div body="">You must have write permission to use this page. Please contact your company admin to give you write access.</div>
      <div buttons="">
        <katapult-button color = "var(--paper-grey-200)" on-click="returnToHomePage">Return to [[config.firebaseData.homePageName]]</katapult-button>
      </div>
    </paper-dialog>
    <paper-dialog id="manageRemoteProcessorsDialog">
      <div title="" secondary-color="">Manage Remote Processors</div>
      <div content="">
        <template is="dom-repeat" items="[[remoteEmails]]">
          <div class="emailCard"><span>[[item]]</span><iron-icon icon="clear" on-click="removeEmail"></iron-icon></div>
        </template>
        <div class="remoteEmailsInputContainer">
          <paper-input id="emailInput" label="Enter new email..." no-label-float="" error-message="Invalid email" pattern="^[\\w\\.]+@[a-zA-Z_]+?\\.[a-zA-Z]{2,3}\$" required=""></paper-input>
          <katapult-button icon="add_circle" iconOnly noBorder on-click="addEmail"></katapult-button>
        </div>
      </div>
      <div buttons="">
        <katapult-button color = "var(--secondary-color)" text-color= "white" width: 70px dialog-dismiss>Done</katapult-button>
      </div>
    </paper-dialog>
    <!-- TODO: this dialog needs to be converted to a katapult-dialog so that it can be a proper modal -->
    <paper-dialog id="associationResultsDialog" no-cancel-on-esc-key no-cancel-on-outside-click>
      <div title="" amber="">Warning</div>
      <div body="">
        <paper-dialog-scrollable dialog-element="[[\$.associationResultsDialog]]">
          <p>
            </p><div>You may have a photo association problem. The photos being uploaded are not associating to locations as well as they should.</div>
            <div>Please go back and check that all sync photo information was filled out correctly.</div>
            <div>This information is emailed to project manager so that they can review the data and provide feedback so potential issues can be avoided in the future.</div>
          <p></p>
          <ul>
            <template is="dom-repeat" items="[[packagedJobs]]" as="job">
              <li>[[job.name]]</li>
              <ul>
                <template is="dom-repeat" items="[[job.associationResults.cameras]]" as="camera" index-as="cameraIndex">
                  <li>Camera [[add(1, cameraIndex)]] - <span class="cameraAssociationPercentage" red\$="[[camera.poorAssociation]]">([[camera.percentAssociated]]%)</span> [[camera.numAssociated]]/[[camera.numPhotos]] Photos Will Associate</li>
                </template>
              </ul>
            </template>
          </ul>
        </paper-dialog-scrollable>
      </div>
      <div buttons="">
        <katapult-button color = "var(--paper-grey-200)" dialog-dismiss on-click="goBackToSyncEntry">Go Back</katapult-button>
        <katapult-button color = "var(--secondary-color)" text-color = "white" dialog-dismiss>Continue</katapult-button>
      </div>
    </paper-dialog>
    <paper-dialog id="failedDialog">
      <div title="" secondary-color="">Failed Photos</div>
      <div content="">
        <paper-dialog-scrollable dialog-element="[[\$.failedDialog]]">
          <template is="dom-repeat" items="[[failedPhotos]]" as="photo">
            <div>[[photo.item.name]]</div>
          </template>
        </paper-dialog-scrollable>
      </div>
      <div buttons="">
        <katapult-button dialog-dismiss>Close</katapult-button>
      </div>
    </paper-dialog>
    
    <!--Time Bucket Dialog-->
    <paper-dialog id="timeBucketDialog" style="width:450px;">
      <h2>Time Bucket Warnings</h2>
      <div>The time buckets listed below are unusually large. You can choose to delete them before running the photo association, or run the association normally, including the large time buckets.</div>
      <paper-dialog-scrollable id="timeBucketBody">
        <ul>
          <template is="dom-repeat" items="{{packagedJobs}}" as="job">
            <li>[[job.name]]</li>
            <template is="dom-repeat" items="{{job.associationResults.largeTimeBuckets}}">
              <div style="margin-top:5px;margin-left:15px;">{{item.type}} ({{item.description}}): {{item.timeAmount}}</div>
            </template>
          </template>
        </ul>
      </paper-dialog-scrollable>
      <div class="buttons">
        <katapult-button color = "var(--secondary-color)" text-color = "white" dialog-confirm on-click="deleteLargeTimeBuckets">Delete, Then Associate</katapult-button>
        <katapult-button color = "var(--secondary-color)" text-color = "white" dialog-confirm>Associate Normally</katapult-button>
      </div>
    </paper-dialog>
    <!-- TODO: this dialog needs to be converted to a katapult-dialog so that it can be a proper modal -->
    <paper-dialog id="confirmDialog" class="pageloadHidden" layered="false" entry-animation="scale-up-animation" exit-animation="fade-out-animation" on-iron-overlay-canceled="confirmDialogCancelCallback" no-cancel-on-esc-key no-cancel-on-outside-click>
      <paper-dialog-scrollable>
        <h2>{{confirmDialogHeading}}</h2>
        <div style="display:table; min-height:138px; width:calc(100% - 48px); table-layout: fixed;">
          <span id="confirmBody" style="display:table-cell; vertical-align:middle;">
            <span id="confirmDialogBody"></span> <!-- <span>{{confirmDialogBody}}</span> Changed so HTML can be injected instead of just text.-->
            <template is="dom-if" if="{{equal(confirmDialogBodyType, 'cameraConfigError')}}">
              <template is="dom-repeat" items="{{invalidCameraSettingsDisplayList}}" as="camera">
                <div style="margin: 15px 0px;">
                  <h4>{{camera.details.body}} {{camera.details.lens}}</h4>
                  <template is="dom-repeat" items="{{toArray(camera.errorDetails)}}">
                    <div style="display: flex; align-items: center">
                      <template is="dom-if" if="{{item.value}}">
                        <iron-icon class="cameraConfigErrorPass" icon="icons:check"></iron-icon>
                      </template>
                      <template is="dom-if" if="{{!item.value}}">
                        <iron-icon class="cameraConfigErrorFail" icon="icons:clear"></iron-icon>
                      </template>
                      <span>{{item.label}}</span>
                    </div>
                  </template>
                </div>
              </template>
              <span>Please make sure you're using an approved camera and settings (<a href="https://katapultpro.com/recommended-camera">https://katapultpro.com/recommended-camera<a/>) for height photos in the future.</span>
            </template>
          </span>
        </div>
        <div>
          <template is="dom-if" if={{confirmDialogDismissiveText}}>
            <katapult-button on-click="confirmDialogCancelCallback" noBorder style\$="{{confirmDialogDismissiveStyle}}">{{confirmDialogDismissiveText}}</katapult-button>
          </template>
          <katapult-button class="confirmButton" on-click="confirmDialogCallback" dialog-confirm="" autofocus="" style\$="{{confirmDialogAffirmativeStyle}}">{{confirmDialogAffirmativeText}}</katapult-button>
        </div>
      </paper-dialog-scrollable>
    </paper-dialog>
    
    <katapult-auth user="{{user}}" user-group="{{userGroup}}" signed-in="{{signedIn}}" read-only="{{readOnlyUser}}" title="[[config.firebaseData.name]] Upload" signup-link="https://katapultpro.com/signup" no-signup="[[!config.firebaseData.offerLicenses]]">
      <div slot="title-content">
        <p style="margin: 0;">[[config.firebaseData.name]] Upload</p>
      </div>
      <div slot="description-content">
        <p>[[config.firebaseData.name]] Upload allows you to upload photos.</p>
        <template is="dom-if" if="{{appNameContains(config.firebaseData.name, 'katapult')}}">
          <p>Need some help?  View our <a href="https://katapultpro.com/help/" style="color: white; font-weight: normal; text-decoration: none;">Docs</a></p>
        </template>
      </div>
      <div id="main" on-dragover="preventDefault" on-drop="preventDefault" slot="auth-content">
        <katapult-firebase-worker path="photoheight/company_space/[[userGroup]]/models/attributes" data="{{otherAttributes}}"></katapult-firebase-worker>
        <katapult-toolbar style="flex-shrink: 0;" user-group="[[userGroup]]">
          <span slot="left" style="text-transform: uppercase; font-size: 18pt; text-color: var(--primary-text-color-faded); font-weight: lighter;">katapult upload</span>
        </katapult-toolbar>
        <div id="progressContainer"><progress-bar min="0" max="[[add(numPages, -1)]]" value="[[add(pageNumber, -1)]]" label="STEP [[pageNumber]] OF [[numPages]]"></progress-bar></div>
        <div id="slideContainer">
          <div>
            <span>How many cameras are you using?</span>
            <template is="dom-if" if="[[numPhotos]]">
              <span class="warning">Changing the number of cameras will clear current cameras!</span>
            </template>
            <div id="numCameraPickerContainer">
              <span>[[numCameras]]</span>
              <div class="buttons">
                <katapult-button on-click="changeCameraCount" icon="arrow_drop_up" iconOnly noBorder disabled="[[equal(numCameras, 3)]]"></katapult-button>
                <katapult-button on-click="changeCameraCount" icon="arrow_drop_down" iconOnly noBorder disabled="[[equal(numCameras, 1)]]"></katapult-button>
              </div>
            </div>
          </div>
          <div>
            <span>Click on a camera to add photos</span>
            <div id="cameraDropZoneContainer">
              <template is="dom-repeat" items="[[cameras]]" as="camera">
                <div class="cameraDropZone" on-dragover="cameraDropZoneDragover" on-dragleave="cameraDropZoneDragleave" on-drop="cameraDropZoneDrop" on-click="cameraDropZoneClick">
                  <input type="file" accept=".jpg,.jpeg" multiple="" on-change="fileInputChanged">
                  <div class="title">Camera [[add(index, 1)]]</div>
                  <div class="body">
                    <span class="numPhotos">[[camera.numPhotos]]</span>
                    <span class="photosLabel">photos</span>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div style="flex-direction: row; justify-content: center;">
            <div id="findSyncsContainer" style="min-width: 460px;" class="subPagesContainer">
              <div visible\$="[[equal(1, findSyncsPageNumber)]]">
                <span>Find sync photos</span>
                <katapult-button size = "36px" color = "var(--secondary-color)" text-color = "white" on-click="findSyncsAutomatically">Automatically</katapult-button>
                <katapult-button size = "30px" on-click="findSyncsManually">Manually</katapult-button>
              </div>
              <div visible\$="[[equal(2, findSyncsPageNumber)]]">
                <template is="dom-if" if="[[and(busy, syncSearch)]]">
                  <span>Searching for sync photos...</span>
                </template>
                <template is="dom-if" if="[[andNot(syncSearch, busy)]]">
                  <span>Searching for sync photos complete!</span>
                </template>
                <div id="findSyncsProgressContainer">
                  <div id="findSyncsProgress"></div>
                  <template is="dom-if" if="[[and(busy, syncSearch)]]">
                    <div class="gears">
                      <iron-icon icon="settings"></iron-icon>
                      <iron-icon icon="settings"></iron-icon>
                    </div>
                  </template>
                  <template is="dom-if" if="[[andNot(busy, syncSearch)]]">
                    <div style="margin-top:87.2px;">Loading</div>
                  </template>
                  <template is="dom-if" if="[[!busy]]" restamp="">
                    <iron-icon icon="check-circle"></iron-icon>
                  </template>
                </div>
                <template is="dom-if" if="[[syncSearch]]">
                  <span>Found [[autoFoundSyncPhotos.length]] sync photo[[s(autoFoundSyncPhotos.length)]]</span>
                </template>
              </div>
              <div visible\$="[[equal(3, findSyncsPageNumber)]]">
                <template is="dom-if" if="[[findSyncsError]]"><span>Find syncs automatically encountered some errors</span></template>
                <span style="margin-bottom: 16px;">Mark[[if(syncSearch, ' any remaining')]] sync photos</span>
                <div style="height: 100%; justify-content: flex-start; padding: 0 12px; margin: 0 12px; width: auto; overflow-y: auto;">
                  <template is="dom-repeat" items="[[cameras]]" as="camera" index-as="cameraIndex">
                    <div class="cameraRow">
                      <div class="title">Camera [[add(1, cameraIndex)]]</div>
                      <div class="body">
                        <template is="dom-repeat" items="[[camera.photos]]" as="photo">
                          <div class="thumbnail" on-click="thumbnailClicked" highlight\$="[[isCurrentSyncImage(syncEditPhoto, photo)]]" sync\$="[[isValidSync(photo, 1, photo.*)]]"><div class="background" style="background-image: url([[photo.thumbnail]]);" rotation\$="[[photo.exif.rotation]]"></div></div>
                        </template>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div id="syncEditContainer" visible\$="[[syncEditContainerVisible]]" katapult-drop-down-fit-into="">
              <bind-path base="{{cameras}}" path="[[syncEditPhotoPath]]" value="{{syncEditPhoto}}"></bind-path>
              <div id="syncEditPhotoContainer">
                <p style="margin-bottom: 16px; font-size: 12pt;">Enter sync details for this photo</p>
                <div style="flex-grow: 1;"></div>
                <katapult-photo id="syncPhotoViewer" src="[[getObjectUrl(syncEditPhoto.item)]]" zoom="" auto-resize=""></katapult-photo>
                <div style="flex-grow: 1;"></div>
              </div>
              <div id="syncEditInputContainer">
                <div style="flex-grow: 1;"></div>
                <template is="dom-repeat" items="[[syncInputModels]]">
                  <input-element style="width: 100%;" user-group="[[userGroup]]" attribute_name="[[item.attr]]" model="[[item]]" date-string-format value="[[getByKey(syncEditPhoto, item.attr, syncEditPhoto.*)]]" fit-into="[[\$.findSyncsContainer]]" time-bucket-users="[[timeBucketUsers]]" time-bucket-roles="[[timeBucketRoles]]" camel-case no-label-float on-value-changed="setSyncEditPhotoProperty" other-attributes="[[otherAttributes]]" no-default-date filter-to-time-bucket-users="[[filterToTimeBucketUsers]]" filter-to-time-bucket-roles="[[filterToTimeBucketRoles]]"></input-element>
                </template>
                <div style="flex-grow: 1;"></div>
                <template is="dom-if" if="[[equal(2, findSyncsPageNumber)]]">
                  <div id="syncToolbar">
                    <template is="dom-repeat" items="[[autoFoundSyncPhotos]]" as="photo">
                      <div class="thumbnail" on-click="thumbnailClicked" highlight\$="[[isCurrentSyncImage(syncEditPhoto, photo)]]" sync\$="[[isValidSync(photo, 1, photo.*)]]"><div class="background" style="background-image: url([[photo.thumbnail]]);" rotation\$="[[photo.exif.rotation]]"></div></div>
                    </template>
                  </div>
                </template>
                <div style="display: flex; justify-content: space-between; width: 100%;">
                  <template is="dom-if" if="[[equal(findSyncsPageNumber, 2)]]">
                    <katapult-button icon="arrow_back" disabled="[[equal(syncEditPhotoNumber, 1)]]" iconOnly noBorder on-click="changeFoundSyncPhoto"></katapult-button>
                    <template is="dom-if" if="[[syncEditPhoto.jobId]]">
                      <template is="dom-if" if="[[equal(syncEditPhotoNumber, autoFoundSyncPhotos.length)]]">
                        <katapult-button icon="check_circle" iconOnly noBorder on-click="doneEditingSyncPhoto"></katapult-button>
                      </template>
                      <template is="dom-if" if="[[!equal(syncEditPhotoNumber, autoFoundSyncPhotos.length)]]">
                        <katapult-button icon="arrow_forward" iconOnly noBorder on-click="changeFoundSyncPhoto"></katapult-button>
                      </template>
                    </template>
                    <template is="dom-if" if="[[!syncEditPhoto.jobId]]">
                      <template is="dom-if" if="[[equal(syncEditPhotoNumber, autoFoundSyncPhotos.length)]]">
                        <katapult-button id="skipButton1" icon="redo" iconOnly noBorder on-click="doneEditingSyncPhoto"></katapult-button>
                        <paper-tooltip for="skipButton1">Skip this photo</paper-tooltip>
                      </template>
                      <template is="dom-if" if="[[!equal(syncEditPhotoNumber, autoFoundSyncPhotos.length)]]">
                        <katapult-button id="skipButton2" icon="redo" iconOnly noBorder on-click="changeFoundSyncPhoto"></katapult-button>
                        <paper-tooltip for="skipButton2">Skip this photo</paper-tooltip>
                      </template>
                    </template>
                  </template>
                  <template is="dom-if" if="[[equal(findSyncsPageNumber, 3)]]">
                    <div style="flex-grow: 1;"></div>
                    <katapult-button icon="check_circle" iconOnly noBorder on-click="doneEditingSyncPhoto"></katapult-button>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div style="flex-direction:row;">
            <div style="display:flex; flex-direction:column; flex-grow:1; overflow-y: auto; justify-content: flex-start; margin-left:24px; height: 100%;">
              <span style="margin-bottom: 16px;">The following photos will be uploaded to the following jobs.<br>Please make sure that everything looks correct, then continue.<br>Photos that have already been uploaded will be skipped.</span>
              <template is="dom-repeat" items="[[packagedJobs]]" as="job">
                <div class="jobRow">
                  <div class="title">
                    <div style="flex: 1 0 0; text-align: left; padding-left: 5px;">
                      <template is="dom-if" if="[[equal(userGroup, 'alpine_communication_corp')]]">
                        <paper-checkbox class="fieldCompleteCheckbox" checked="{{job.fieldComplete}}">Field Complete</paper-checkbox>
                      </template>
                    </div>
                    <div style="flex: 1 0 0;">
                      [[job.name]]
                    </div>
                    <div style="flex: 1 0 0;"></div>
                  </div>
                  <div class="body">
                    <template is="dom-repeat" items="[[job.cameras]]" as="camera" index-as="cameraIndex">
                      <div class="cameraRow" style="height: 400px; width: 400px;">
                        <div class="title">Camera [[add(1, cameraIndex)]] ([[getNumPhotos(camera.photos)]])</div>
                        <div class="body">
                          <template is="dom-repeat" items="[[camera.photos]]" as="photo">
                            <div class="thumbnail" faded\$="[[photo.status.uploadComplete]]" sync\$="[[isValidSync(photo, 1, photo.*)]]">
                              <template is="dom-if" if="[[photo.status.uploadComplete]]">
                                <div class="icon"><iron-icon icon="cloud-done"></iron-icon></div>
                              </template>
                              <div class="background" style="background-image: url([[photo.thumbnail]]);" rotation\$="[[photo.exif.rotation]]"></div></div>
                          </template>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </div>
            <div style="margin: 20px;">
              <div id="actionPanel">
                <paper-header-content opened>
                  <paper-cell slot="header">Notifications<iron-icon icon="mail" style="margin-left:10px;"></iron-icon></paper-cell>
                    <div slot="content" style="padding: 8px 16px; text-align:left;">
                      <paper-checkbox disabled="[[forceNotifyProjectManagers]]" checked="[[notifyProjectManagers]]" on-click="toggleUserRequestNotifyProjectManagers">Notify Project Managers</paper-checkbox>
                      <paper-checkbox checked="{{notifyRemoteProcessors}}">Notify Remote Processors</paper-checkbox>
                      <template is="dom-if" if="[[notifyRemoteProcessors]]">
                        <katapult-button id="manageNotificationEmails" icon="create" iconOnly noBorder on-click="manageNotificationEmails"></katapult-button>
                        <paper-tooltip for="manageNotificationEmails">Manage Remote Processors</paper-tooltip>
                      </template>
                    </div>
                </paper-header-content>
                <paper-header-content opened>
                  <paper-cell slot="header">Tools<iron-icon icon="build" style="margin-left:10px;"></iron-icon></paper-cell>
                    <div slot="content" style="padding: 8px 16px; text-align:left;">
                      <template is="dom-if" if="{{companyModules.post_construction_inspection}}">
                        <paper-checkbox checked="{{pci}}" style="margin-bottom:10px;">PCI Workflow</paper-checkbox>
                      </template>
                      <paper-checkbox checked="{{associatePhotos}}" on-change="checkLargeTimeBuckets">Associate Photos</paper-checkbox>
                    </div>
                </paper-header-content>
                <katapult-button on-click="beginUpload" disabled="[[uploadDisabled]]" display = "block" margin-top = "10px" margin-bottom = "10px">Upload</katapult-button>
              </div>
            </div>
          </div>
          <div style="flex-direction: row; justify-content: center;">
            <div id="uploadContainer" class="subPagesContainer">
              <div visible\$="[[equal(1, uploadPageNumber)]]">
                <span>Uploading photos...</span>
                <div id="uploadProgressContainer">
                  <div id="uploadProgress"></div>
                  <template is="dom-if" if="[[!busy]]" restamp="">
                    <iron-icon icon="check-circle" style="color: var(--secondary-color);"></iron-icon>
                  </template>
                </div>
                <span>[[numSuccess]] photo[[s(numSuccess)]] uploaded</span>
                <template is="dom-if" if="[[failedPhotos.length]]">
                  <div><span>[[failedPhotos.length]] photo[[s(failedPhotos.length)]] failed</span><katapult-button color = "var(--primary-text-color-faded)" icon="help" iconOnly noBorder on-click="showFailedDetails"></katapult-button></div>
                </template>
              </div>
              <div visible\$="[[equal(2, uploadPageNumber)]]">
                <div style="display: flex; flex-direction: column;">
                  <span style="margin: 8px;">Upload Complete!</span>
                  <span style="margin: 8px;">[[numSuccess]] photo[[s(numSuccess)]] uploaded successfully to [[packagedJobs.length]] job[[s(packagedJobs.length)]]</span>
                  <template is="dom-if" if="[[failedPhotos.length]]">
                    <div style="margin: 8px;"><span>[[failedPhotos.length]] photo[[s(failedPhotos.length)]] failed</span><katapult-button icon="help" iconOnly noBorder on-click="showFailedDetails"></katapult-button></div>
                  </template>
                  <template is="dom-repeat" items="[[packagedJobs]]" as="job">
                    <a href="[[getPhotoPageUrl(job.$key)]]" target="_blank" style="text-decoration: none">
                        <katapult-button style="margin: 8px;"><iron-icon icon="open-in-new"></iron-icon>[[job.name]] Photos</katapult-button>
                    </a>
                  </template>     
                </div>
                <template is="dom-if" if="[[failedPhotos.length]]">
                  <katapult-button on-click="retryFailedPhotos">Retry failed photos</katapult-button>
                </template>
                <katapult-button on-click="reset">Start over</katapult-button>
              </div>
            </div>
          </div>
        </div>
        <div id="buttonsContainer">
          <template is="dom-if" if="[[lessThan(pageNumber, 5)]]">
            <katapult-button on-click="changePageNumber" icon="arrow_back" iconOnly noBorder disabled="[[changePageDisabled('back', pageNumber, numPhotos, busy)]]"></katapult-button>
          </template> 
          <template is="dom-if" if="[[lessThan(pageNumber, 4)]]">
            <katapult-button on-click="changePageNumber" icon="arrow_forward" iconOnly noBorder disabled="[[changePageDisabled('forward', pageNumber, numPhotos, busy, findSyncsPageNumber)]]"></katapult-button>
          </template>
        </div>
      </div>
    </katapult-auth>
`;
  }

  static get is() {
    return 'katapult-upload-page';
  }
  static get properties() {
    return {
      autoFoundSyncPhotos: {
        type: Array,
        value: []
      },
      busy: {
        type: Boolean,
        value: false
      },
      cameras: {
        type: Array
      },
      failedPhotos: {
        type: Array,
        value: []
      },
      filterToTimeBucketRoles: {
        type: Boolean,
        value: false
      },
      filterToTimeBucketUsers: {
        type: Boolean,
        value: false
      },
      notifyProjectManagers: {
        type: Boolean,
        computed: 'calcNotifyProjectMangers(forceNotifyProjectManagers, userRequestNotifyProjectManagers)'
      },
      notifyRemoteProcessors: {
        type: Boolean,
        value: true
      },
      numCameras: {
        type: Number,
        value: 2
      },
      numPages: {
        type: Number,
        value: 5,
        observer: 'numPagesChanged'
      },
      numPhotos: {
        type: Number,
        value: 0
      },
      packagedJobs: {
        type: Object,
        value: []
      },
      pageNumber: {
        type: Number,
        value: 1,
        observer: 'pageNumberChanged'
      },
      remoteEmails: {
        type: Array,
        value: []
      },
      syncEditPhoto: {
        type: Object
      },
      syncEditPhotoNumber: {
        type: Number,
        computed: 'calcSyncEditPhotoNumber(syncEditPhoto, autoFoundSyncPhotos.length)'
      },
      syncEditPhotoPath: {
        type: String
      },
      syncEditContainerVisible: {
        type: Boolean,
        value: false,
        observer: 'calcSyncEditContainerOffset'
      },
      syncInputModels: {
        type: Array,
        value: []
      },
      timeBucketRoles: {
        type: Array,
        value: () => []
      },
      timeBucketUsers: {
        type: Object,
        value: () => {}
      },
      uploadDisabled: {
        type: Boolean,
        value: true
      },
      invalidCameraSettingsList: {
        type: Object,
        value: {}
      },
      invalidCameraSettingsDisplayList: {
        type: Array,
        value: []
      }
    };
  }
  static get observers() {
    return [
      'computeTimeBucketUsers(syncEditPhoto.jobId)',
      'resizeCameras(numCameras)',
      'loadRemoteEmails(userGroup)',
      'syncEditPhotoChanged(syncEditPhoto.*, syncInputModels)',
      'updateSyncInputModels(userGroup)',
      'showPermissionRequiredDialog(readOnlyUser)'
    ];
  }
  ready() {
    super.ready();
    this.appConfiguration = new AppConfiguration(this);

    zip.workerScriptsPath = '../_resources/js/open-source/zipjs/';

    this.classifier = new ImageClassifier('mobilenet_v1_0.50_128', 128);
    /* Setup Circular Progress Bars */
    this.findSyncsProgress = new ProgressBar.Circle(this.$.findSyncsProgress, {
      strokeWidth: 6,
      easing: 'linear',
      duration: 100,
      color: '#007299',
      trailColor: '#eee',
      trailWidth: 1,
      svgStyle: null
    });
    this.uploadProgress = new ProgressBar.Circle(this.$.uploadProgress, {
      strokeWidth: 6,
      easing: 'linear',
      duration: 100,
      color: '#007299',
      trailColor: '#eee',
      trailWidth: 1,
      svgStyle: null
    });
    this.reset();
  }
  add(a, b) {
    return a + b;
  }
  toArray(obj) {
    return ToArray(obj);
  }
  addFiles(files, cameraIndex) {
    let camera = this.cameras[cameraIndex];
    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      if (file.type == 'image/jpeg') {
        let fileId = this.getFileId(file);
        file.cameraIndex = cameraIndex;
        file.index = camera.files.length;
        if (!camera.fileIds[fileId]) {
          camera.fileIds[fileId] = true;
          this.push(`cameras.${cameraIndex}.files`, file);
        }
      }
    }
    this.set(`cameras.${cameraIndex}.numPhotos`, camera.files.length);
    this.numPhotos = this.cameras.reduce((sum, camera) => sum + camera.numPhotos, 0);
  }
  and(a, b) {
    return a && b;
  }
  andNot(a, b) {
    return a && !b;
  }
  appNameContains(appName, searchString) {
    return (appName || '').toLowerCase().indexOf(searchString.toLowerCase()) != -1;
  }
  showPermissionRequiredDialog() {
    if (this.readOnlyUser != null) this.$.permissionRequiredDialog.opened = this.readOnlyUser;
  }
  returnToHomePage() {
    window.location.href = `${window.location.origin}/${config.firebaseData.homePage}`;
  }
  async sendErrorEmail(error, isWarning) {
    // create zip writer
    console.log(`error`, error);
    let writer = await new Promise((res) => zip.createWriter(new zip.BlobWriter(), res));
    await new Promise((res) =>
      writer.add(
        `packaged_jobs.json`,
        new zip.BlobReader(
          new Blob(
            [
              JSON.stringify(
                this.packagedJobs,
                (key, value) => {
                  return value === undefined ? null : value;
                },
                4
              )
            ],
            { type: 'application/json' }
          )
        ),
        res
      )
    );
    await new Promise((res) =>
      writer.add(
        `update.json`,
        new zip.BlobReader(
          new Blob(
            [
              JSON.stringify(
                this.updateSnapshot,
                (key, value) => {
                  return value === undefined ? null : value;
                },
                4
              )
            ],
            { type: 'application/json' }
          )
        ),
        res
      )
    );

    // create blob
    let blob = await new Promise((res) => writer.close(res));

    // get uid
    let uid = 'no_uid';
    if (katapultAuth && katapultAuth.user && katapultAuth.user.uid) {
      uid = katapultAuth.user.uid;
    }

    // write data to firebase storage
    let storagePath = `upload_page_error/${this.userGroup || 'no_user_group'}/${uid}/${new Date().toString()}`;
    let storageRef = firebase.storage().ref(storagePath);
    storageRef.put(blob).then(() => {
      let emailObject = {
        addresses: ['katapultpro-events@katapultengineering.com'],
        subject: 'UPLOAD PAGE ERROR',
        body: `Path to Zip File: ${storagePath}\r\n${isWarning ? 'Warning' : 'Error'}: ${error}`,
        group_tag: 'internal'
      };
      // send email
      var emailReqKey = FirebaseWorker.ref('/photoheight/server_requests/email/requests/').push(emailObject).key;
      return FirebaseWorker.ref('/photoheight/server_requests/email/responses/' + emailReqKey).on('value', (snapshot) => {
        var response = snapshot.val();
        if (response != null) {
          snapshot.ref.remove();
          return;
        }
      });
    });
  }
  customWarn(...args) {
    let warningString = args.filter((e) => typeof e == 'string').join('\n');
    // only send an error email for permission warnings
    if (warningString.includes('permission_denied')) {
      this.sendErrorEmail(warningString, true);
    }
    return console.oldWarn(...args);
  }
  async beginUpload(e) {
    try {
      console.oldWarn = console.warn;
      console.warn = this.customWarn.bind(this);
      this.pageNumber++;
      this.uploadPageNumber = 1;
      this.busy = true;
      this.invalidCameraSettingsList = {};
      this.invalidCameraSettingsDisplayList = [];
      let photos = [];
      let update = {};
      // Create a lookup of companies each job is shared with by jobId.
      let sharingLookup = {};
      // Create a lookup of collection sets by jobId.
      let collectionSetsLookup = {};
      // Create an array to store promises in as we request various resources in parallel for the jobs we are uploading to.
      let promises = [];
      // Loop through jobs and request the various resources.
      this.packagedJobs.forEach((job) => {
        // Get the collection sets for this job and put them into the collection set lookup.
        promises.push(
          FirebaseWorker.ref(`photoheight/jobs/${job.$key}/photo_folders`)
            .once('value')
            .then((s) => {
              collectionSetsLookup[job.$key] = s.val();
            })
        );
        // Get the collection sets for this job and put them into the collection set lookup.
        promises.push(
          FirebaseWorker.ref(`photoheight/jobs/${job.$key}/sharing`)
            .once('value')
            .then((s) => {
              sharingLookup[job.$key] = s.val();
            })
        );
      });
      // Wait for all of the parallel resource requests to finish.
      await Promise.all(promises);
      // Create a lookup of collectionSetIds by cameraId.
      let cameraLookup = {};
      for (let jobId in collectionSetsLookup) {
        let collectionSets = collectionSetsLookup[jobId];
        for (let collectionSetId in collectionSets) {
          let collectionSet = collectionSets[collectionSetId];
          for (let cameraId in collectionSet.cameras) {
            cameraLookup[cameraId] = collectionSetId;
          }
        }
      }

      this.packagedJobs.forEach((job) => {
        let jobId = job.$key;
        let collectionSets = collectionSetsLookup[jobId];

        // default whether this job is done based on whether Notify Remote Processors is checked when uploading
        let jobDone = !this.notifyRemoteProcessors;
        // loop through all of this jobsFolders and if any of them are not set to done then set this jobs done attribute to false
        if (collectionSets && Object.values(collectionSets).some((collectionSet) => !collectionSet.done)) jobDone = false;

        // if Notify Remote Processors is not checked and all the other photo folders in the job are done then we can mark this job done
        // it will then be hidden on the dashboard until "Include Completed" is checked
        UpdateJobPermissions(jobId, this.userGroup, { done: jobDone, collection_sets_done: jobDone });

        let photoFolderId = FirebaseWorker.ref().push().key;
        let photoFolder = {
          numPhotos: 0,
          numUploaded: 0,
          numTagged: 0,
          numAssociated: 0,
          date_created: firebase.database.ServerValue.TIMESTAMP,
          cameras: {},
          done: !this.notifyRemoteProcessors,
          job_id: jobId,
          status: 'Uploading'
        };
        if (this.pci) photoFolder.type = 'pci';
        let jobTagPhotos = {};
        job.cameras.forEach((camera) => {
          let cameraId = camera.cameraId;
          let cameraAssociation = job.associationResults.cameras.find((x) => x.camera_id == cameraId);
          let newCamera = {
            numPhotos: 0,
            numUploaded: 0,
            numTagged: 0,
            numAssociated: 0,
            date_created: firebase.database.ServerValue.TIMESTAMP,
            collectionDetails: {}
          };
          if (this.associatePhotos && cameraAssociation) {
            newCamera.numAssociated = cameraAssociation.numAssociated;
            newCamera.numTagged = cameraAssociation.numTagged;
          }
          camera.photos.forEach((photo) => {
            if (!photo.status.uploadComplete) {
              let photoSize = Number(photo.exif.image_width) + Number(photo.exif.image_height);
              let photoDetails = photo.exif.camera_model + photo.exif.lens + photoSize;
              // Check if the photo matches to a camera model
              let matchingCameraModel = calibratePhoto.getMatchingCameraModel(photo.exif);
              // If no matching model is found, then determine the errors with the camera
              if (!matchingCameraModel) {
                // only flag canon cameras, but exclude anything in the list below
                let cameraMakesToExclude = ['powershot'];
                if (
                  !this.invalidCameraSettingsList[photoDetails] &&
                  (photo.exif.camera_make || '').toLowerCase() == 'canon' &&
                  !cameraMakesToExclude.some((x) => (photo.exif.camera_model || '').toLowerCase().includes(x))
                ) {
                  let cameraConfigError = calibratePhoto.getCameraConfigError(photo.exif);
                  this.invalidCameraSettingsList[photoDetails] = {
                    errorDetails: cameraConfigError,
                    details: {
                      body: photo.exif.camera_model,
                      lens: photo.exif.lens,
                      height: photo.exif.image_height,
                      width: photo.exif.image_width
                    },
                    job: jobId,
                    user: photo.user || null
                  };
                }
              }
              photo._jobId = jobId;
              photo.addToDashboard = this.notifyRemoteProcessors;
              // It's tagged as a sync
              if (photo.jobId) {
                photo.exif.photofirst_data = {
                  job: {
                    upload_added: {
                      jobname: photo.jobId
                    }
                  },
                  sync: {
                    upload_added: {
                      time: photo.time || '',
                      timezone: photo.timezone || '',
                      user: photo.user || null,
                      team_members: photo.team_members || null
                    }
                  }
                };
                update[photo._jobId + '/jobTagPhotos/' + photo._key] = photo.jobId;
                jobTagPhotos[photo._key] = photo.jobId;
              }
              if (photo.status.existingCameraId) {
                photo._folderId = cameraLookup[photo._cameraId];
              } else {
                newCamera.numPhotos++;
                photo._folderId = photoFolderId;
                // if (photo.jobId) {
                //   photoFolder.numTagged++;
                //   newCamera.numTagged++;
                // }
              }
              photo.exif.camera_id = photo._cameraId;
              photo.exif.folder_id = photo._folderId;
              delete photo.exif.rotation; //rotation is handled by the upload script
              photo.exif.uploaded_by = this.user.uid;
              photo.exif.status = 'upload_started';
              photo.exif.synced_time = photo.syncedTime ?? null;
              photo.exif['.priority'] = '' + photo.exif.camera_model + photo.exif.date_taken;

              // Check if the photo already existed or not. If not, upload the entire
              // exif as new data.  If the photo did exist, then loop through the
              // keys in the exif object and just update them so we don't overwrite
              // the photofirst_data. The reason we don't always loop over the exif
              // keys is that the .priority key can't be individually set on a non-existent object
              if (photo.status.existingKey) {
                for (let exifKey in photo.exif) {
                  let exifData = photo.exif[exifKey];

                  // make sure we are not creating an update with any undefined values
                  if (photo.exif.hasOwnProperty(exifKey) && exifData !== undefined) {
                    update[`${photo._jobId}/photos/${photo._key}/${exifKey}`] = exifData;
                  }
                }
              } else {
                update[photo._jobId + '/photos/' + photo._key] = photo.exif;
              }

              update[photo._jobId + '/photo_summary/' + photo._key] = {
                '.priority': photo.exif['.priority'],
                name: photo.exif.filename,
                camera_id: photo._cameraId,
                status: 'upload_started'
              };
              if (photo.jobId) {
                update[photo._jobId + '/photo_summary/' + photo._key].data = true;
                update[photo._jobId + '/photo_summary/' + photo._key].job = true;
                update[photo._jobId + '/photo_summary/' + photo._key].sync = true;
                update[photo._jobId + '/photo_summary/' + photo._key].job_id = photo.jobId;
              }
              photos.push(photo);
            }
          });
          if (newCamera.numPhotos > 0) {
            photoFolder.cameras[cameraId] = newCamera;
            photoFolder.numPhotos += newCamera.numPhotos;
            photoFolder.numAssociated += newCamera.numAssociated;
            photoFolder.numTagged += newCamera.numTagged;
          }
        });
        if (photoFolder.numPhotos > 0) {
          update[jobId + '/photo_folders/' + photoFolderId] = photoFolder;
        }

        // Get list of companies that this job is shared with so we can update parts of the job summary.
        let sharing = sharingLookup[jobId];
        for (let companyId in sharing) {
          // If the new collection set we are adding to this job has photos, update the counters job summary.
          if (photoFolder.numPhotos > 0) {
            FirebaseWorker.ref(`photoheight/counters/${companyId}/${jobId}`).transaction((counters) => {
              counters = counters || {};
              counters.numPhotos = counters.numPhotos || { value: 0 };
              counters.numPhotos.value += photoFolder.numPhotos;
              counters.numPhotos.last_modified = firebase.database.ServerValue.TIMESTAMP;
              counters.numUploaded = counters.numUploaded || { value: 0, last_modified: firebase.database.ServerValue.TIMESTAMP };
              if (photoFolder.numAssociated) {
                counters.numAssociated = counters.numAssociated || { value: 0, last_modified: firebase.database.ServerValue.TIMESTAMP };
                counters.numAssociated.value += photoFolder.numAssociated;
              }
              if (photoFolder.numTagged) {
                counters.numTagged = counters.numTagged || { value: 0, last_modified: firebase.database.ServerValue.TIMESTAMP };
                counters.numTagged.value += photoFolder.numTagged;
              }
              return counters;
            });
          }
        }

        let jobPermissionsData = {};
        // Loop through the job tag photos and store them on the job summary.
        for (let photoId in jobTagPhotos) {
          jobPermissionsData[`jobTagPhotos/${photoId}`] = jobTagPhotos[photoId];
        }
        // If we are uploading a pci collection set to this job, update the collection set types in the job summary.
        jobPermissionsData[`collection_set_types/${photoFolder.type || 'unclassified'}`] = true;
        UpdateJobPermissions(jobId, this.userGroup, jobPermissionsData, {
          sharing
        });

        if (job.fieldComplete) {
          if (this.uploadOptions && this.uploadOptions.set_job_status) {
            setJobMetadata(
              this.userGroup,
              { [this.uploadOptions.set_job_status.property]: this.uploadOptions.set_job_status.value },
              jobId
            );
          }
        }
      });
      if (Object.keys(this.invalidCameraSettingsList || {}).length > 0) {
        this.invalidCameraSettingsDisplayList = Object.values(this.invalidCameraSettingsList || {});
        firebase.functions().httpsCallable('email')({
          template: 'incorrectCameraSettings',
          jobs: this.packagedJobs,
          cameraDetails: this.invalidCameraSettingsList,
          userGroup: this.userGroup,
          user: firebase.auth().currentUser.email || 'A User'
        });
        let body =
          'You are uploading photos that use incorrect camera settings. Your company admins have been notified that any height photos uploaded with the wrong settings will not be able to be calibrated. Camera Errors:';
        this.confirm('Warning!', body, 'Okay', '', '', 'cameraConfigError');
      }
      // store the update in a global that we can use for debugging if things get hairy
      this.updateSnapshot = update;
      FirebaseWorker.ref('photoheight/jobs')
        .update(update)
        .then(async () => {
          if (this.associatePhotos) {
            let associationUpdate = {};

            // Combine the associations into a single update
            this.packagedJobs.forEach((job) => {
              let results = job.associationResults;
              Object.assign(associationUpdate, results.update);
            });
            await FirebaseWorker.ref().update(associationUpdate);
          }
          this.numPhotosUploading = photos.length;
          this.numUploaded = 0;
          this.numSuccess = 0;
          this.failedPhotos = [];
          if (this.notifyProjectManagers) this.emailProjectManagers();
          if (this.notifyRemoteProcessors) this.emailRemoteProcessors();
          if (!this.uploader) this.uploader = new Uploader(this.config.firebaseConfigs[this.config.appName], { parallelCount: 8 });
          this.uploader
            .upload(photos, (details) => {
              if (details.status === 'failed') {
                this.push('failedPhotos', details.photo);
                this.numUploaded++;
                this.uploadProgress.animate(this.numUploaded / this.numPhotosUploading);
                this.$.failedDialog.notifyResize();
              } else if (details.status === 'complete') {
                this.numSuccess++;
                FirebaseWorker.ref(
                  `photoheight/photo_counts/${this.userGroup}/photo_upload_count/${SquashNulls(details, 'photo', '_jobId') || 'null'}`
                ).transaction((count) => ++count);
                this.numUploaded++;
                this.uploadProgress.animate(this.numUploaded / this.numPhotosUploading);
              }
            })
            .then(() => {
              if (this.alreadyTriedFailedPhotos) {
                this.busy = false;
                this.uploadPageNumber = 2;
              } else {
                this.alreadyTriedFailedPhotos = true;
                this.retryFailedPhotos();
              }
            });
        });
    } catch (error) {
      this.sendErrorEmail(error);
    }
  }
  confirm(heading, body, affirmativeText, dismissiveText, affirmativeStyle, confirmDialogBodyType, callback, cancelCallback, otherButtons) {
    this.confirmDialogHeading = heading || '';
    this.$.confirmDialogBody.innerHTML = body || '';
    this.confirmDialogAffirmativeText = affirmativeText || '';
    this.confirmDialogDismissiveText = dismissiveText || '';
    this.confirmDialogAffirmativeStyle = affirmativeStyle || '';
    if (affirmativeStyle != null && affirmativeStyle != '') {
      this.confirmDialogDismissiveStyle = 'color:black';
    } else {
      this.confirmDialogDismissiveStyle = '';
    }
    this.confirmDialogCallback = callback || function () {};
    this.confirmDialogBodyType = confirmDialogBodyType;
    this.confirmDialogCancelCallback = cancelCallback || function () {};
    this.confirmDialogOtherButtons = otherButtons;
    this.$.confirmDialog.open();
  }
  async computeTimeBucketUsers() {
    let timeBucketUsers = {};
    let timeBucketRoles = [];

    // If we don't have a job id, then we don't need to compute the time bucket users or roles
    if (!this.syncEditPhoto?.jobId) {
      this.set('filterToTimeBucketUsers', false);
      this.set('filterToTimeBucketRoles', false);
      this.set('timeBucketUsers', timeBucketUsers);
      this.set('timeBucketRoles', timeBucketRoles);
      return;
    }

    // Get the job's nodes
    const nodes = await FirebaseWorker.ref(`photoheight/jobs/${this.syncEditPhoto.jobId}/nodes`)
      .once('value')
      .then((s) => s.val());
    let foundTimeBucketUser = false;
    let foundTimeBucketRole = false;
    let userInfoPromises = [];

    for (const nodeId in nodes) {
      // Get the time bucket data for the node
      const timeBuckets = nodes[nodeId].attributes?.time_bucket;
      for (const [key, timeBucketValue] of Object.entries(timeBuckets || {})) {
        // Check if the time bucket has a uid or team members
        if (timeBucketValue.teamMembers) {
          for (const [index, teamMemberData] of Object.entries(timeBucketValue.teamMembers.team || {})) {
            // Add the team member's uid to the time bucket users
            if (teamMemberData.uid) {
              // If the user is already in the time bucket users, skip them
              if (timeBucketUsers[teamMemberData.uid]) continue;

              // Set the user's status to pending while we're fetching their info
              timeBucketUsers[teamMemberData.uid] = 'Pending';

              // Fetch the user's info
              userInfoPromises.push(
                FirebaseWorker.ref(`user_info/${teamMemberData.uid}`)
                  .once('value')
                  .then((s) => {
                    const userEmail = s.val().email;
                    timeBucketUsers[teamMemberData.uid] = userEmail;
                    foundTimeBucketUser = true;
                  })
              );
            }
            // Add the team member's role to the time bucket roles
            if (teamMemberData.role && !timeBucketRoles.includes(teamMemberData.role)) {
              timeBucketRoles.push(teamMemberData.role);
              foundTimeBucketRole = true;
            }
          }
        } else if (timeBucketValue.uid) {
          // If the user is already in the time bucket users, skip them
          if (timeBucketUsers[timeBucketValue.uid]) continue;

          // Set the user's status to pending while we're fetching their info
          timeBucketUsers[timeBucketValue.uid] = 'Pending';

          // Fetch the user's info
          userInfoPromises.push(
            FirebaseWorker.ref(`user_info/${timeBucketValue.uid}`)
              .once('value')
              .then((s) => {
                const userEmail = s.val().email;
                timeBucketUsers[timeBucketValue.uid] = userEmail;
                foundTimeBucketUser = true;
              })
          );
        }
      }
    }
    // Wait until we have all the user's info
    await Promise.all(userInfoPromises);

    if (foundTimeBucketUser) this.set('filterToTimeBucketUsers', true);
    if (foundTimeBucketRole) this.set('filterToTimeBucketRoles', true);
    this.set('timeBucketUsers', timeBucketUsers);
    this.set('timeBucketRoles', timeBucketRoles);
  }
  calcNotifyProjectMangers() {
    return this.forceNotifyProjectManagers || this.userRequestNotifyProjectManagers;
  }
  calcSyncEditContainerOffset() {
    if (this.syncEditContainerVisible && this.$.syncPhotoViewer) {
      var offsetMatrix = new WebKitCSSMatrix(window.getComputedStyle(this.$.slideContainer).transform);
      this.$.syncPhotoViewer.$.canvas.canvasPanZoomOffset = {
        x: -offsetMatrix.e,
        y: -offsetMatrix.f
      };
    }
  }
  calcSyncEditPhotoNumber() {
    return this.autoFoundSyncPhotos.indexOf(this.syncEditPhoto) + 1;
  }
  cameraDropZoneClick(e) {
    e.currentTarget.querySelector('input').click();
  }
  cameraDropZoneDragover(e) {
    e.preventDefault();
    e.currentTarget.setAttribute('hover', true);
  }
  cameraDropZoneDragleave(e) {
    e.currentTarget.removeAttribute('hover');
  }
  cameraDropZoneDrop(e) {
    e.preventDefault();
    this.addFiles(e.dataTransfer.files, e.model.index);
    e.currentTarget;
    e.currentTarget.removeAttribute('hover');
  }
  changeCameraCount(e) {
    if (e.currentTarget.icon.includes('up') && this.numCameras < 3) this.numCameras++;
    else if (e.currentTarget.icon.includes('down') && this.numCameras > 1) this.numCameras--;
  }
  changeFoundSyncPhoto(e) {
    let currentIndex = this.autoFoundSyncPhotos.indexOf(this.syncEditPhoto);
    if (e.currentTarget.icon && e.currentTarget.icon.includes('back') && currentIndex > 0) currentIndex--;
    else if (currentIndex < this.autoFoundSyncPhotos.length - 1) currentIndex++;
    let photo = this.autoFoundSyncPhotos[currentIndex];
    if (photo) this.setSyncDialogImage(photo.item);
  }
  changePageDisabled(button) {
    if (this.busy) return true;
    if (button === 'back') {
      if (this.pageNumber === 1) return true;
    }
    if (button === 'forward') {
      if (this.pageNumber === this.numPages) return true;
      if (this.pageNumber === 2 && !this.numPhotos) return true;
      if (this.pageNumber === 3 && this.findSyncsPageNumber < 3) return true;
    }
  }
  changePageNumber(e) {
    if (this.pageNumber == 3 && e.currentTarget.icon.includes('forward')) {
      if (this.cameras.every((camera) => camera.photos.some((photo) => this.isValidSync(photo)))) {
        this.pageNumber++;
      } else {
        this.$.toast.show('Please fill out sync details for at least one photo on every camera (even if you forgot a sync photo).');
      }
    } else if (e.currentTarget.icon.includes('forward') && this.pageNumber < this.numPages) this.pageNumber++;
    else if (e.currentTarget.icon.includes('back') && this.pageNumber > 1) this.pageNumber--;
  }
  clickedThumbnail(e) {}
  doneEditingSyncPhoto() {
    this.syncEditContainerVisible = false;
    if (this.findSyncsPageNumber === 2 && !this.busy) this.findSyncsPageNumber = 3;
  }
  emailProjectManagers() {
    if (Object.keys(this.projectManagers ?? {}).length) {
      let bodyRows = [`Photoset uploaded by ${this.user.email}`, '', ''];
      this.packagedJobs.forEach((job) => {
        bodyRows.push(
          `- ${job.name} ${encodeURI((globalThis.config?.firebaseData?.origin_url ?? window.location.origin) + '/map#' + job.$key)}`
        );
        job?.associationResults?.cameras.forEach((camera, cameraIndex) => {
          bodyRows.push(
            `\t- Camera ${cameraIndex + 1} - (${camera.percentAssociated}%) ${camera.numAssociated}/${
              camera.numPhotos
            } Photos Will Associate`
          );
        });
      });
      bodyRows.push('');
      bodyRows.push('-Katapult Engineering');

      let sentKey = FirebaseWorker.ref('photoheight/server_requests/email/requests').push({
        addresses: Object.values(this.projectManagers ?? {}).map((x) => x.email),
        subject: 'Upload Page Association Results',
        body: bodyRows.join('\n'),
        group_tag: 'photo_uploads'
      }).key;
      FirebaseWorker.ref('photoheight/server_requests/email/responses/' + sentKey).on('value', (s) => {
        if (s.exists()) {
          let res = s.val();
          if (!res.success) this.$.toast.show('An error occurred while emailing the project managers');
          else s.ref.remove();
        }
      });
    }
  }
  emailRemoteProcessors() {
    if (this.remoteEmails && this.remoteEmails.length > 0) {
      let bodyRows = [`${this.numPhotosUploading} photos are being uploaded:`, ''];
      if (this.userGroup == 'DRG_solutions') bodyRows.push([`Photoset uploaded by ${this.user.email}`]);
      this.packagedJobs.forEach((job) => {
        let numPhotos = job.cameras.reduce(
          (total, camera) => total + camera.photos.filter((photo) => !photo.status.uploadComplete).length,
          0
        );
        bodyRows.push(`${numPhotos} photos to ${job.name}`);
      });
      bodyRows = bodyRows.concat([
        '',
        `You may access the dashboard here: ${encodeURI((globalThis.config?.firebaseData?.origin_url ?? window.location.origin) + '/dashboard')}`,
        '',
        '-Katapult Engineering'
      ]);

      let sentKey = FirebaseWorker.ref('photoheight/server_requests/email/requests').push({
        addresses: this.remoteEmails,
        subject: 'Photos are available to be processed',
        body: bodyRows.join('\n'),
        group_tag: 'photo_uploads'
      }).key;
      FirebaseWorker.ref('photoheight/server_requests/email/responses/' + sentKey).on('value', (s) => {
        if (s.exists()) {
          let res = s.val();
          if (!res.success) this.$.toast.show('An error occurred while emailing the remote processors');
          else s.ref.remove();
        }
      });
    }
  }
  equal(a, b) {
    return a === b;
  }
  fileInputChanged(e) {
    this.addFiles(e.currentTarget.files, e.model.index);
    e.currentTarget.value = null;
  }
  findSyncsAutomatically(e) {
    this.syncSearch = true;
    this.busy = true;
    this.findSyncsPageNumber = 2;
    let files = [];
    this.cameras.forEach((camera, i) => {
      this.set(`cameras.${i}.photos`, new Array(camera.files.length));
      files = files.concat(camera.files);
    });
    let i = 0;
    this.classifier
      .fromFiles(files, (err, results) => {
        this.findSyncsProgress.animate(++i / this.numPhotos);
        if (err) {
          this.findSyncsError = true;
          if (err.item) this.push('failedPhotos', { item: err.item });
          this.$.failedDialog.open();
          this.$.failedDialog.notifyResize();
          console.log(err);
        }
        if (results && results.item)
          GetExif(results.item).then((exif) => {
            results.exif = exif;
            this.set(`cameras.${results.item.cameraIndex}.photos.${results.item.index}`, results);
            if (results.labels && results.labels[0].label === 'sync' && results.labels[0].confidence > 0.9) {
              this.push('autoFoundSyncPhotos', results);
              if (!this.syncEditContainerVisible) {
                this.setSyncDialogImage(results.item);
                this.syncEditContainerVisible = true;
              }
            }
          });
      })
      .then(() => {
        this.busy = false;
        if (!this.syncEditContainerVisible) setTimeout(() => (this.findSyncsPageNumber = 3), 1000);
      });
  }
  findSyncsManually() {
    this.syncSearch = false;
    this.busy = true;
    this.findSyncsPageNumber = 2;
    let files = [];
    this.cameras.forEach((camera, i) => {
      this.set(`cameras.${i}.photos`, new Array(camera.files.length));
      files = files.concat(camera.files);
    });
    let i = 0;
    let results = files.map(async (file) => {
      try {
        let result = {
          item: file,
          labels: [],
          thumbnail: await GetExifThumbnail(file),
          exif: await GetExif(file)
        };
        this.findSyncsProgress.animate(++i / this.numPhotos);
        this.set(`cameras.${file.cameraIndex}.photos.${file.index}`, result);
      } catch (e) {
        this.push('failedPhotos', { item: file });
        this.$.failedDialog.open();
        this.$.failedDialog.notifyResize();
        throw e;
      }
    });
    Promise.all(results).then(() => {
      this.findSyncsPageNumber = 3;
      this.busy = false;
    });
  }
  getByKey(item, key) {
    if (item) return item[key];
  }
  getFileId(file) {
    if (file) return `${file.name}_${file.lastModified}_${file.size}`;
  }
  getNumPhotos(photos) {
    if (Array.isArray(photos)) {
      let numSkipped = photos.filter((photo) => photo.status.uploadComplete).length;
      if (numSkipped) return `${photos.length - numSkipped} Photos - ${numSkipped} Skipped`;
      return `${photos.length} Photos`;
    }
  }
  getObjectUrl(file) {
    return file && URL.createObjectURL(file);
  }
  if(condition, then, otherwise) {
    return condition ? then : otherwise;
  }
  goBackToSyncEntry() {
    this.pageNumber = 3;
  }
  isCurrentSyncImage(syncEditPhoto, photo) {
    if (syncEditPhoto && photo) {
      let currentSyncId = this.getFileId(syncEditPhoto.item);
      let photoId = this.getFileId(photo.item);
      return currentSyncId != null && photoId != null && currentSyncId === photoId;
    }
  }
  isValidSync(photo, string) {
    if (photo) {
      let valid = this.syncInputModels.map((model) => {
        if (model.attr != 'team_members') {
          return photo[model.attr] != null && photo[model.attr] != '';
        } else {
          return Object.values(SquashNulls(photo, model.attr, 'team') || {}).some((x) => x && x.uid && x.role);
        }
      });
      if (valid.every((x) => x)) return string ? 'true' : true;
      if (valid.some((x) => x)) return string ? 'false' : false;
    }
  }
  loadRemoteEmails(userGroup) {
    if (!this.get('remoteEmails.length')) {
      // Fetch remote emails.
      FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/remote_emails`).once('value', (s) => {
        if (s.exists()) this.set('remoteEmails', Object.values(s.val()));
      });
    }
  }
  lessThan(a, b) {
    return a < b;
  }
  manageNotificationEmails() {
    this.$.manageRemoteProcessorsDialog.open();
  }
  numPagesChanged() {
    this.style.setProperty('--num-pages', this.numPages);
  }
  async pageNumberChanged(newPage, oldPage) {
    this.style.setProperty('--page-index', this.pageNumber - 1);
    if (this.pageNumber === 2) {
      this.findSyncsError = false;
    } else if (this.pageNumber === 3) {
      if (oldPage == 2) {
        this.autoFoundSyncPhotos = [];
        this.findSyncsPageNumber = 1;
      }
      this.syncEditContainerVisible = false;
      this.findSyncsProgress.animate(0);
    } else if (this.pageNumber === 4) {
      let temp = {};
      let packagedCamera = { photos: [], jobId: null };
      let savePackagedCamera = () => {
        if (!temp[packagedCamera.jobId]) {
          let name = null;
          let query = Path.get(this, '$.jobChooser.$.jobs');
          if (query) name = Path.get(query.child(packagedCamera.jobId), 'name');
          temp[packagedCamera.jobId] = { cameras: {}, name };
        }
        if (!temp[packagedCamera.jobId].cameras[packagedCamera.index]) {
          temp[packagedCamera.jobId].cameras[packagedCamera.index] = { photos: [] };
        }
        packagedCamera.photos.forEach((photo) => temp[packagedCamera.jobId].cameras[packagedCamera.index].photos.push(photo));
        packagedCamera = { photos: [], jobId: null };
      };
      this.cameras.forEach((camera) => {
        // Sort photos on camera by date taken.
        camera.photos.sort((a, b) => a.exif.date_taken - b.exif.date_taken);
        camera.photos.forEach((photo) => {
          if (photo.jobId) {
            if (packagedCamera.jobId) savePackagedCamera();
            packagedCamera.jobId = photo.jobId;
            packagedCamera.index = photo.item.cameraIndex;
          }
          photo.date_taken = photo.exif.date_taken;
          photo.filename = photo.item.name;
          packagedCamera.photos.push(photo);
        });
        savePackagedCamera();
      });
      let checks = [];
      temp = ToArray(temp);

      if (!this.uploader) this.uploader = new Uploader(this.config.firebaseConfigs[this.config.appName], { parallelCount: 8 });
      temp.forEach((job) => {
        job.cameras = ToArray(job.cameras);
        job.cameras.forEach((camera) => {
          camera.cameraId = FirebaseWorker.ref().push().key;
          camera.photos.forEach((photo) => {
            checks.push(
              this.uploader.checkForExistingPhoto(job.$key, photo.exif.name_date).then((result) => {
                photo.status = result;
                photo._key = photo.$key = photo.status.existingKey || uuidv4();
                photo._cameraId = photo.camera_id = photo.status.existingCameraId || camera.cameraId;
              })
            );
          });
        });
      });

      await Promise.all(checks);

      this.forceNotifyProjectManagers = false;
      this.projectManagers = {};

      // Check association percentages.
      for (let packagedJob of temp) {
        packagedJob.name = await FirebaseWorker.ref(`photoheight/jobs/${packagedJob.$key}/name`)
          .once('value')
          .then((s) => s.val());
        let projectManager = await FirebaseWorker.ref(`photoheight/jobs/${packagedJob.$key}/metadata/project_manager`)
          .once('value')
          .then((s) => s.val());
        if (projectManager) {
          const projectManagerUserInfo = await FirebaseWorker.ref(`user_info/${projectManager}`)
            .once('value')
            .then((s) => s.val());
          const projectManagerEmail = projectManagerUserInfo.email;
          if (!projectManagerUserInfo.deleted) this.projectManagers[projectManager] = { email: projectManagerEmail };
        }

        let nodes = await FirebaseWorker.ref(`photoheight/jobs/${packagedJob.$key}/nodes`)
          .once('value')
          .then((s) => s.val());
        let connections = await FirebaseWorker.ref(`photoheight/jobs/${packagedJob.$key}/connections`)
          .once('value')
          .then((s) => s.val());
        let photos = packagedJob.cameras.reduce((acc, camera) => acc.concat(camera.photos), []);

        packagedJob.nodes = nodes;
        packagedJob.connections = connections;
        packagedJob.photos = photos;

        let results = await AssociatePhotos(packagedJob.$key, nodes, connections, photos);

        let jobCreator = await FirebaseWorker.ref(`photoheight/jobs/${packagedJob.$key}/job_creator`)
          .once('value')
          .then((s) => s.val());
        let threshold =
          (await FirebaseWorker.ref(`photoheight/company_space/${jobCreator}/models/config/upload/association_threshold`)
            .once('value')
            .then((s) => s.val())) || 93;

        for (let camera of results.cameras) {
          if (camera.percentAssociated < threshold) {
            camera.poorAssociation = true;
            this.forceNotifyProjectManagers = true;
          } else {
            camera.poorAssociation = false;
          }
        }
        results.jobId = packagedJob.$key;
        results.name = packagedJob.name;
        packagedJob.associationResults = results;
      }

      if (Object.keys(this.projectManagers).length == 0)
        this.projectManagers = await FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/admins`)
          .once('value')
          .then((s) => s.val());

      // Removes admin users who opted out of email notifications in the client support dashboard
      for (const user in this.projectManagers) {
        if (this.projectManagers[user].email_opt_in === false) delete this.projectManagers[user];
      }

      this.packagedJobs = temp;

      // Show results dialog.
      if (this.forceNotifyProjectManagers) this.$.associationResultsDialog.open();
      this.uploadDisabled = false;
    }
  }
  checkLargeTimeBuckets() {
    if (this.associatePhotos && this.packagedJobs.some((x) => x.associationResults.largeTimeBuckets.length)) {
      this.$.timeBucketDialog.open();
    }
  }
  async deleteLargeTimeBuckets() {
    for (let job of this.packagedJobs) {
      let update = {};
      job.associationResults.largeTimeBuckets.forEach((bucket) => {
        if (bucket.nodeId) {
          delete job.nodes[bucket.nodeId].attributes.time_bucket[bucket.id];
        } else {
          delete job.connections[bucket.connId].sections[bucket.sectId].multi_attributes.time_bucket[bucket.id];
        }
        update[
          `photoheight/jobs/${job.$key}/${
            bucket.nodeId ? `nodes/${bucket.nodeId}/attributes` : `connections${bucket.connId}/sections/${bucket.sectId}/multi_attributes`
          }/time_bucket/${bucket.id}`
        ] = null;
      });
      job.associationResults = await AssociatePhotos(job.$key, job.nodes, job.connections, job.photos);
      Object.assign(job.associationResults.update, update);
    }
  }
  preventDefault(e) {
    e && e.preventDefault();
  }
  resizeCameras() {
    let temp = [];
    for (let i = 0; i < this.numCameras; i++)
      temp.push({
        files: [],
        fileIds: {},
        numPhotos: 0
      });
    this.cameras = temp;
    this.numPhotos = 0;
  }
  addEmail(e) {
    if (this.$.emailInput.validate() && this.remoteEmails.indexOf(this.$.emailInput.value) == -1) {
      this.push('remoteEmails', this.$.emailInput.value);
      this.$.emailInput.value = '';
    }
  }
  removeEmail(e) {
    this.splice('remoteEmails', e.model.index, 1);
  }
  reset() {
    this.uploadDisabled = true;
    this.alreadyTriedFailedPhotos = false;
    this.failedPhotos = [];
    this.pageNumber = 1;
    this.findSyncsPageNumber = 1;
    this.uploadPageNumber = 1;
    this.pci = false;
    this.packagedJobs = [];
    this.notifyRemoteProcessors = true;
    this.invalidCameraSettingsList = {};
    this.invalidCameraSettingsDisplayList = [];
    this.resizeCameras();
    this.findSyncsProgress.set(0);
    this.uploadProgress.set(0);
  }
  async retryFailedPhotos() {
    let photos = [];
    this.failedPhotos.forEach((photo) => photos.push(photo));
    this.failedPhotos = [];
    this.numUploaded -= photos.length;
    this.uploadPageNumber = 1;
    this.busy = true;
    this.uploadProgress.set(this.numUploaded / this.numPhotosUploading);
    if (photos.length > 0) {
      await this.uploader.upload(photos, (details) => {
        if (details.status === 'failed') {
          this.push('failedPhotos', details.photo);
          this.numUploaded++;
          this.uploadProgress.animate(this.numUploaded / this.numPhotosUploading);
        } else if (details.status == 'complete') {
          this.numSuccess++;
          FirebaseWorker.ref(
            `photoheight/photo_counts/${this.userGroup}/photo_upload_count/${SquashNulls(details, 'photo', '_jobId') || 'null'}`
          ).transaction((count) => ++count);
          this.numUploaded++;
          this.uploadProgress.animate(this.numUploaded / this.numPhotosUploading);
        }
      });
    }
    this.busy = false;
    this.uploadPageNumber = 2;
  }
  s(x) {
    return x !== 1 ? 's' : '';
  }
  showFailedDetails() {
    this.$.failedDialog.open();
  }
  setSyncDialogImage(file) {
    this.syncEditPhotoPath = `${file.cameraIndex}.photos.${file.index}`;
  }
  setSyncEditPhotoProperty(e) {
    this.persistedProperties = this.persistedProperties || {};
    if (e.model.item.attr) {
      if (e.model.item.persist && e.detail.value)
        this.set(`persistedProperties.${e.model.item.attr}`, JSON.parse(JSON.stringify(e.detail.value)));
      this.set(`syncEditPhoto.${e.model.item.attr}`, e.detail.value);
    }
  }
  syncEditPhotoChanged() {
    (this.syncInputModels || []).forEach((model) => {
      if (model.persist && this.get(`syncEditPhoto.${model.attr}`) === undefined && this.get(`persistedProperties.${model.attr}`))
        this.set(`syncEditPhoto.${model.attr}`, JSON.parse(JSON.stringify(this.get(`persistedProperties.${model.attr}`))));
      if (model.attr == 'team_members' && !this.get(`syncEditPhoto.${model.attr}`))
        this.set(`syncEditPhoto.${model.attr}`, { team: [{ uid: '', role: '' }] });
    });
  }
  thumbnailClicked(e) {
    this.setSyncDialogImage(e.model.photo.item);
    if (!this.syncEditContainerVisible) this.syncEditContainerVisible = true;
  }
  toggleUserRequestNotifyProjectManagers(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (this.forceNotifyProjectManagers) this.userRequestNotifyProjectManagers = false;
    else this.userRequestNotifyProjectManagers = !this.userRequestNotifyProjectManagers;
  }
  async updateSyncInputModels() {
    if (this.userGroup) {
      const teamMembers = await FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/models/attributes/team_members`)
        .once('value')
        .then((s) => s.val());
      const defaultPicklist = await FirebaseWorker.ref(
        `photoheight/company_space/${this.userGroup}/models/attributes/time_zone/picklists/default`
      )
        .once('value')
        .then((s) => s.val());
      let temp = [
        { attr: 'jobId', label: 'Job', _gui_element: 'job_chooser' },
        { attr: 'time', _gui_element: 'date-time-dialog' },
        {
          attr: 'timezone',
          _gui_element: 'dropdown',
          persist: true,
          picklist: defaultPicklist || [
            { label: 'GMT -3', value: -3 },
            { label: 'GMT -4', value: -4 },
            { label: 'GMT -5', value: -5 },
            { label: 'GMT -6', value: -6 },
            { label: 'GMT -7', value: -7 },
            { label: 'GMT -8', value: -8 },
            { label: 'GMT -9', value: -9 },
            { label: 'GMT -10', value: -10 }
          ]
        }
      ];
      temp.push(
        teamMembers
          ? { attr: 'team_members', _gui_element: 'team-members', persist: true }
          : { attr: 'user', _gui_element: 'user-dropdown', persist: true }
      );
      this.syncInputModels = temp;
    }
  }
  getPhotoPageUrl(jobKey) {
    let pathSplit = window.location.pathname.split('/').slice(0, -2).join('/');
    return pathSplit + `/photos/#${jobKey}`;
  }
}
window.customElements.define(KatapultUploadPage.is, KatapultUploadPage);
